module.exports = __webpack_public_path__ + "static/book-e64c3c9db9d8f566dfff18893bc71cd6.jpg";